module.exports = __webpack_public_path__ + "static/media/NoNetwork.aa704d56.svg";